import noSearchFound from "assets/no-search-found.svg";
export const bodyDataAndKeyTypes = [
  {
    key: "isChecked",
    type: "checkbox",
  },
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
  {
    key: "productOriginalPrice",
    type: "",
    prepend: "Rs. ",
  },
];

export const footerData = {
  title: "No record found",
  subTtitle: "No such product exists. Create one?",
  imgSrc: noSearchFound,
  alt: "no search found",
};

export enum BANNER_TYPES {
  "CMS" = "CMS",
  "PRODUCT" = "PRODUCT",
  "PROMO" = "PROMO",
}

export enum BANNER_IMAGE_DIMENSIONS {
  W400Xh400 = "w400Xh400",
  W2000Xh375 = "w2000Xh375",
}
